export default {"src":"/_next/static/media/big-logo.dde69850.svg","height":281,"width":281,"blurWidth":0,"blurHeight":0};